import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartCreate = (
	`mutation ($input: CartInput!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
		cartCreate(input: $input) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartCreate;
